import type { RequisitionListOutput } from "@/api/tools";

type OperationalRow = Extract<RequisitionListOutput["items"][number], { waiting_on: unknown }>;
export function RequisitionWaiting({ waiting_on: items, waiting_count: count }: Pick<OperationalRow, "waiting_on" | "waiting_count">) {
  if (!count) return <span className="muted">No recorded waiting item</span>;
  return <div style={{ display: "grid", gap: 4 }}>{items.map(item => <span key={item.id}>{item.title}</span>)}{count > items.length && <span className="muted">+ {count - items.length} more recorded items</span>}</div>;
}
